// @flow

import { Store } from '@homie/flux';
import Dispatcher from 'dispatcher';
import { LOAD_SCREENING_PARAMS } from 'modules/dashboards/api/action_types/ScreeningParamsActionTypes';
import type { Action } from 'modules/dashboards/api/action_types/ScreeningParamsActionTypes';

let state = {
  degree_levels: {},
  seniority_years: {},
  position_types: {},
  enterprise_types: {},
  relationship_moral_person: {},
  relationship_physical_person: {},
  enterprise_sizes: {},
  number_of_branches: {}
};

class ScreeningParamsStore extends Store {
  constructor(): void {
    super();
    Dispatcher.register(this._reducer);
  }

  get screeningParams() {
    return {
      degreeLevels: state.degree_levels,
      seniorityYears: state.seniority_years,
      positionTypes: state.position_types,
      relationshipMoralPerson: state.relationship_moral_person,
      relationshipPhysicalPerson: state.relationship_physical_person,
      enterpriseTypes: state.enterprise_types,
      enterpriseSizes: state.enterprise_sizes,
      numberOfBranches: state.number_of_branches
    };
  }

  _reducer = (action: Action) => {
    if (action.type !== LOAD_SCREENING_PARAMS) return;

    const screeningParams = action.screeningParams.reduce(
      (accumulator, screeningParam) => {
        accumulator[screeningParam.slug || screeningParam.value] = {
          ...screeningParam
        };
        return accumulator;
      },
      {}
    );

    state = { ...state, [action.name]: screeningParams };
    this.notify();
  };
}

export default new ScreeningParamsStore();
